/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './applicant_individual';
import './applicant_business';
import '../../../connect/v2/resources/address';
import '../card';
import '../offer';
import '../../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "application_flow": {
                "nested": {
                  "ApplicationFlow": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "state": {
                        "type": ".squareup.corporate_card.resources.application_flow.ApplicationFlow.State",
                        "id": 2,
                        "rule": "optional"
                      },
                      "applicantIndividual": {
                        "type": ".squareup.corporate_card.resources.application_flow.ApplicantIndividual",
                        "id": 3,
                        "rule": "optional"
                      },
                      "applicantBusiness": {
                        "type": ".squareup.corporate_card.resources.application_flow.ApplicantBusiness",
                        "id": 4,
                        "rule": "optional"
                      },
                      "shippingAddress": {
                        "type": ".squareup.connect.v2.resources.Address",
                        "id": 5,
                        "rule": "optional"
                      },
                      "cards": {
                        "type": ".squareup.corporate_card.resources.Card",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "offer": {
                        "type": ".squareup.corporate_card.resources.Offer",
                        "id": 7,
                        "rule": "optional"
                      },
                      "enabledFeatures": {
                        "type": "string",
                        "id": 8,
                        "rule": "repeated"
                      },
                      "declineReasons": {
                        "type": ".squareup.corporate_card.resources.application_flow.ApplicationFlow.DeclineReason",
                        "id": 9,
                        "rule": "repeated"
                      },
                      "submittedAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 10,
                        "rule": "optional"
                      },
                      "completedAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 11,
                        "rule": "optional"
                      },
                      "manualReviewInformation": {
                        "type": ".squareup.corporate_card.resources.application_flow.ApplicationFlow.ManualReviewInformation",
                        "id": 12,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "State": {
                        "values": {
                          "AF_STATE_DO_NOT_USE": 0,
                          "PULLING_CREDIT_REPORT": 12,
                          "GENERATING_OFFER_DECISION": 13,
                          "GENERATING_OFFER_DECISION_ASYNC": 15,
                          "PENDING": 1,
                          "VERIFYING_PHONE": 2,
                          "VERIFYING_PERSONAL": 3,
                          "VERIFYING_BUSINESS": 4,
                          "VERIFYING_CONTROLLING_INDIVIDUAL": 11,
                          "SUBMITTED": 5,
                          "ISSUING_CARD": 6,
                          "ONBOARDED": 7,
                          "MANUAL_REVIEW": 8,
                          "DECLINED": 9,
                          "CANCELED": 10,
                          "PULLING_HARD_CREDIT_REPORT": 14
                        }
                      },
                      "DeclineReason": {
                        "values": {
                          "AF_AAR_DO_NOT_USE": 0,
                          "PERSONAL_VERIFICATION_FAILURE": 1,
                          "BUSINESS_VERIFICATION_FAILURE": 2,
                          "CARD_NON_APPLICANT_BUSINESS_OWNERS": 3,
                          "BENEFICIAL_OWNER_VERIFICATION_FAILURE": 4,
                          "BUSINESS_MANAGER_VERIFICATION_FAILURE": 5,
                          "ADVERSE_ACCOUNT_ACTIVITY": 6,
                          "BUSINESS_ADDRESS_VERIFICATION_FAILURE": 7,
                          "APPLICANT_AGE_UNDER_18": 8,
                          "SOFT_CREDIT_PULL_FAILURE": 9,
                          "DATA_QUALITY_FAILURE": 10,
                          "VANTAGE_SCORE_BELOW_THRESHOLD": 11,
                          "ACH_RISK_SCORE_BELOW_THRESHOLD": 12,
                          "DEBT_COVERAGE_RATIO_BELOW_THRESHOLD": 13,
                          "ACTIVE_CREDIT_CARD_FAILURE": 14,
                          "ACTIVE_LINE_OF_CREDIT_FAILURE": 15,
                          "UNSUPPORTED_STATE_FAILURE": 16,
                          "LINKED_ACCOUNT_ACTIVITY": 17,
                          "UNCHARACTERISTIC_PAYMENT_ACTIVITY": 18,
                          "CHARGEBACK_HISTORY": 19,
                          "CASH_ADVANCING": 20,
                          "CHARITY_POLITICAL_ORG": 21
                        }
                      },
                      "ManualReviewInformation": {
                        "fields": {
                          "state": {
                            "type": ".squareup.corporate_card.resources.application_flow.ApplicationFlow.ManualReviewInformation.State",
                            "id": 1,
                            "rule": "optional"
                          },
                          "sspToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "State": {
                            "values": {
                              "MR_STATE_DO_NOT_USE": 0,
                              "AWAITING_DOCUMENTS": 1,
                              "AWAITING_REVIEW": 2,
                              "AWAITING_ADDITIONAL_DOCUMENTS": 3,
                              "COMPLETED": 4
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.application_flow?.nested?.ApplicationFlow && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.application_flow?.nested?.ApplicationFlow?.nested?.State && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.application_flow?.nested?.ApplicationFlow?.nested?.DeclineReason && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.application_flow?.nested?.ApplicationFlow?.nested?.ManualReviewInformation && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.application_flow?.nested?.ApplicationFlow?.nested?.ManualReviewInformation?.nested?.State) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A corporate-card onboarding ApplicationFlow
 * --
 *
 * SOURCE ApplicationFlow @ squareup/corporate_card/resources/application_flow/application_flow.proto at 18:1
 */
export const ApplicationFlow = $root.lookupType('squareup.corporate_card.resources.application_flow.ApplicationFlow');
fixType(ApplicationFlow, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(ApplicationFlow);
/**
 * SOURCE State @ squareup/corporate_card/resources/application_flow/application_flow.proto at 19:3
 */
ApplicationFlow.State = $root.lookupEnum('squareup.corporate_card.resources.application_flow.ApplicationFlow.State').values;
/**
 * SOURCE DeclineReason @ squareup/corporate_card/resources/application_flow/application_flow.proto at 46:3
 */
ApplicationFlow.DeclineReason = $root.lookupEnum('squareup.corporate_card.resources.application_flow.ApplicationFlow.DeclineReason').values;
/**
 * SOURCE ManualReviewInformation @ squareup/corporate_card/resources/application_flow/application_flow.proto at 110:3
 */
ApplicationFlow.ManualReviewInformation = $root.lookupType('squareup.corporate_card.resources.application_flow.ApplicationFlow.ManualReviewInformation');
fixType(ApplicationFlow.ManualReviewInformation);
Builder.createAndAttachToType(ApplicationFlow.ManualReviewInformation);
/**
 * SOURCE State @ squareup/corporate_card/resources/application_flow/application_flow.proto at 111:5
 */
ApplicationFlow.ManualReviewInformation.State = $root.lookupEnum('squareup.corporate_card.resources.application_flow.ApplicationFlow.ManualReviewInformation.State').values;